@if (enabled()) {
    <div class="satisfaction-survey-icon">
        <button mat-icon-button (click)="toggleSurvey()">
            <mat-icon>mood</mat-icon>
        </button>
    </div>
}

@if (visible()) {
    <div class="survey-popup-container">
        <div class="survey-header">
            <span class="text-xl">We value your feedback!</span>
            <button
                mat-icon-button
                class="btn-close"
                (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="survey-title">
            <!-- <h2>How satisfied are you with iApply?</h2> -->
            <!-- <p>Your feedback helps us improve our application.</p> -->
        </div>

        <form
            class="survey-form w-full"
            [formGroup]="satisfactionSurveyForm">

            <div class="survey-body flex-grow">

                <div class="survay-question">
                    <p>Please rate your experience today:</p>
                    <!-- [initialValue]="satisfactionSurveyForm.get('rating').value" -->
                    <star-rating
                        [formControlName]="'rating'"
                        [starCount]="5"
                        [color]="'primary'">
                    </star-rating>
                </div>

                <div class="survay-question">
                    <p>Feedback or suggestions?</p>

                    <mat-form-field subscriptSizing="dynamic" class="iapply-form-field w-full">
                        <textarea
                            #feedback
                            matInput
                            class="form-control iapply-text-control textarea-control w-full"
                            [formControlName]="'feedback'"
                            rows="4"
                            id="satisfaction-feedback"
                            name="satisfaction-feedback"
                            placeholder="Your feedback..."
                            spellcheck="true"
                            autocapitalize="true"
                            autocomplete="false"
                            autocorrect="true"
                            maxLength="500"></textarea>
                    </mat-form-field>

                    <!-- Debug Error details... -->
                    <!-- <mat-error *ngIf="inputControl.errors">{{ inputControl.errors | json }}</mat-error> -->

                    <!-- Mandatory error -->
                    <!-- <mat-error *ngIf="!isValidationError() && inputControl.errors?.required">
                        {{ mandatoryErrorMessage }}
                    </mat-error> -->

                    <!-- Regular Expression Control Validators -->
                    <!-- <mat-error *ngIf="!isValidationError() && inputControl.errors?.regex">
                        <ng-container *ngFor="let msg of inputControl.errors?.regexErrors; let last = last;">
                            {{ msg }}<ng-container *ngIf="!last">, or </ng-container>
                        </ng-container>
                    </mat-error> -->
                </div>
            </div>
        </form>

        <div class="survey-footer">
            <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="satisfactionSurveyForm.invalid">Submit</button>
            <!-- <button mat-button (click)="onClose()">Close</button> -->
        </div>
    </div>
}
